module.exports = __webpack_public_path__ + "img/pass.6ccf7c46.svg";